import axios from "axios";
import { destroyCookie, parseCookies } from "nookies";
import authApiService from "./api-services/auth.service";
import { helpers } from "./helpers";
import authService from "./services/AuthService";

const getAccessToken = () => {
  const { accessToken } = parseCookies(null);
  return accessToken;
};

const getRefreshToken = () => {
  const { refresh_token } = parseCookies(null);
  return refresh_token;
};

const config = {
  // Same-origin by default (prod is served behind the same host). Set
  // REACT_APP_API_URL to talk to the backend directly — the CRA dev proxy
  // times out on multipart uploads, so dev should point straight at it.
  baseURL: process.env.REACT_APP_API_URL || "/",
  headers: {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    "Access-Control-Allow-Origin": "*",
    // Bypass ngrok-free's interstitial warning page so XHR/API calls reach the
    // dev-server proxy instead of getting the HTML warning back. Harmless in
    // prod: it's a same-origin request and the real backend ignores it.
    "ngrok-skip-browser-warning": "true",
  },
};

const api = axios.create(config);

api.interceptors.request.use(
  (config) => {
    const accessToken = getAccessToken();
    if (config.headers && accessToken && !config.url?.includes("renew"))
      config.headers["Authorization"] = `Bearer ${accessToken ?? ""}`;

    if (config.url?.includes("renew")) (config as any)._retry = true;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response.data;
  },
  async (error) => {
    const originalConfig = error.config;

    if (error.response) {
      if (error.response.status === 403 && !originalConfig._retry) {
        originalConfig._retry = true;
        try {
          const { accessToken, refreshToken } =
            await authApiService.refreshToken(getRefreshToken());
          authService.registerRefreshToken(refreshToken);
          authService.registerAccessToken(accessToken);
          api.defaults.headers.common["Authorization"] = accessToken;

          return api(originalConfig);
        } catch (_error: any) {
          if (_error.response && _error.response.data) {
            return Promise.reject(_error.response.data);
          }

          return Promise.reject(_error);
        }
      }

      if (
        error.response.status === 401 &&
        !originalConfig.url.includes("register") &&
        !originalConfig.url.includes("login")
      ) {
        destroyCookie(null, "accessToken", { path: "/" });
        return helpers.redirectTo("/login");
      }
    }

    return Promise.reject(error.response);
  }
);

export default api;
